const AUTH_FAILED_FLAG = '__appAuthFailedHandled';
const AUTH_EXCLUDED_PATHS = [
  '/api-token-auth/',
  '/admin/api/logout/',
];

export function clearLocalSession() {
  localStorage.removeItem('vuex');
  localStorage.removeItem('jwt');
  localStorage.removeItem('user_role');
  localStorage.removeItem('user');
}

export function resetAuthFailedFlag() {
  window[AUTH_FAILED_FLAG] = false;
}

function isExcludedAuthRequest(url = '') {
  return AUTH_EXCLUDED_PATHS.some(path => url.includes(path));
}

export function handleUnauthorizedResponse(response) {
  if (!response || response.status !== 401) {
    return;
  }

  const requestUrl = response.url || response.request && response.request.url || '';
  if (isExcludedAuthRequest(requestUrl) || !localStorage.getItem('jwt')) {
    return;
  }

  if (window[AUTH_FAILED_FLAG]) {
    return;
  }

  window[AUTH_FAILED_FLAG] = true;
  if (window.getApp) {
    window.getApp.$emit('APP_AUTH_FAILED');
  }
}
